module.exports = __webpack_public_path__ + "static/Review-ipad-img-2-a99ee7b74f169fcb125e1b48485bc33b.jpeg";